import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RequisitionStatus } from '@api/generated/portal-be-admin';
import { RequisitionsPage, useAdminRequisitionStore } from '@features/admin/requisitions';

const adminRequisitionsSearchSchema = z.object({
  q: z.string().optional(),
  status: z.nativeEnum(RequisitionStatus).optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminRequisitionsSearch = z.infer<typeof adminRequisitionsSearchSchema>;

export const Route = createFileRoute('/admin/requisitions/')({
  validateSearch: search => adminRequisitionsSearchSchema.parse(search),
  component: RequisitionsPage,
  beforeLoad: ctx => {
    const { q, status, page, size } = ctx.search;
    useAdminRequisitionStore.getState().loadRequisitions({ q, status, page: page || 1, size: size || 20 });
  },
});
